<template>
  <v-layout column>
    <router-link :to="{ name: 'geoTagShow', params: { tagID: geotag.id } }">
      <v-flex>
        <v-chip icon class="px-2" v-if="region">
          {{ geotag.name }}
          <v-tooltip top>
            <v-icon right slot="activator"> public </v-icon>
            <span>Region</span>
          </v-tooltip>
        </v-chip>

        <v-chip icon class="px-2" v-if="state">
          {{ geotag.name }}
          <v-tooltip top>
            <v-icon right slot="activator"> location_on </v-icon>
            <span>State</span>
          </v-tooltip>
        </v-chip>
      </v-flex>
    </router-link>
    <v-flex v-if="showWorksites"
      >({{ worksites.length }} location{{
        worksites.length === 1 ? "" : "s"
      }})</v-flex
    >
  </v-layout>
</template>

<script>
export default {
  props: ["geotag", "showWorksites"],

  computed: {
    region() {
      if (
        this.geotag.segmentType === "region" ||
        this.geotag["segment_type"] === "region"
      ) {
        return true;
      }
    },
    state() {
      if (
        this.geotag.segmentType === "state" ||
        this.geotag["segment_type"] === "state"
      ) {
        return true;
      }
    },

    worksites() {
      if (this.geotag && this.geotag.worksites?.length) {
        return this.geotag.worksites;
      }
    }
  }
};
</script>
